import { render, staticRenderFns } from "./Percepciones.vue?vue&type=template&id=8dbfdb98&"
import script from "./Percepciones.vue?vue&type=script&lang=js&"
export * from "./Percepciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports